// src/frontend/data/books/DarkForest/data/cap23.js

const CAP23 = {
  id: 23,
  title: "Navegadores (Browsers) y seguridad en Web3",
  sections: [
    {
      heading: "Navegadores más usados en cripto",
      text: [
        "En el mundo cripto la mayoría de la gente usa navegadores como Chrome y Firefox. También es muy popular Brave, especialmente entre quienes valoran la privacidad y el bloqueo de rastreadores.",
        "La ventaja de estos navegadores conocidos es que tienen equipos de seguridad muy fuertes y reciben actualizaciones frecuentes para corregir vulnerabilidades.",
        "Sin embargo, que el navegador sea “famoso” no significa que tú estés automáticamente segura/o: la forma en que lo configuras y las extensiones que instalas puede convertirlo en tu mejor escudo… o en tu punto más débil."
      ]
    },
    {
      heading: "Actualiza siempre tu navegador",
      text: [
        "Regla de oro: mantén tu navegador actualizado a la última versión estable.",
        "Muchas vulnerabilidades críticas se explotan vía navegador (JavaScript malicioso, bugs en el motor de renderizado, fallos en la sandbox, etc.). Los parches de seguridad llegan en forma de actualización.",
        "No postergues las actualizaciones con pensamientos tipo: “luego lo instalo”, “no pasa nada”, “qué flojera reiniciar”. Esa pequeña demora puede ser justo la ventana de tiempo que un atacante necesita.",
        "Siempre que veas que tu navegador pide reiniciar para aplicar una actualización de seguridad, hazlo tan pronto como puedas."
      ]
    },
    {
      heading: "Extensiones: superpoder o bomba de tiempo",
      text: [
        "Las extensiones son uno de los mayores riesgos en navegadores modernos. Una sola extensión maliciosa o comprometida puede:",
        "- Leer todo lo que navegas, incluidas páginas de exchanges y DApps.",
        "- Inyectar JavaScript en sitios que antes eran seguros.",
        "- Registrar formularios, cookies y hasta capturar ciertas interacciones con tu wallet.",
        "Por eso, la regla base es simple: si no necesitas una extensión, no la instales."
      ]
    },
    {
      heading: "Cómo elegir extensiones de forma más segura",
      list: [
        "✅ Instala extensiones solo desde la tienda oficial de tu navegador (Chrome Web Store, Firefox Add-ons, etc.).",
        "✅ Revisa el número de usuarios: miles o millones de usuarios dan más señal de confianza que una extensión con 23 instalaciones.",
        "✅ Lee reseñas recientes: busca comentarios que mencionen cambios sospechosos, comportamientos extraños o actualizaciones agresivas.",
        "✅ Observa quién la mantiene: ¿es una empresa o desarrollador reconocido? ¿Tiene sitio web y código abierto?",
        "✅ Revisa los permisos que solicita: si una extensión de “tema oscuro” pide permiso para leer y modificar TODOS los sitios que visitas, es una alerta roja.",
        "❌ Evita extensiones clonadas con nombres muy similares a las oficiales, sobre todo de wallets o herramientas de seguridad.",
        "❌ Elimina extensiones que ya no usas. Cada extensión es una nueva superficie de ataque."
      ]
    },
    {
      heading: "Separar actividades con varios navegadores",
      text: [
        "Una estrategia sencilla pero muy efectiva es usar navegadores diferentes para distintos niveles de riesgo:",
        "- Navegador A (seguro): para operaciones críticas como firmar transacciones, entrar a exchanges, manejar grandes montos o interactuar con contratos importantes.",
        "- Navegador B (normal): para navegación cotidiana, redes sociales, noticias, YouTube, búsquedas generales, etc.",
        "En el Navegador A:",
        "- Instala solo las extensiones estrictamente necesarias (por ejemplo, una wallet y un bloqueador de anuncios).",
        "- No inicies sesión en todas tus cuentas personales si no hace falta.",
        "- Evita visitar sitios desconocidos o hacer clic en enlaces aleatorios.",
        "Esta separación mental y técnica reduce mucho el impacto si un sitio dudoso o una extensión en tu navegador de uso diario se ve comprometido."
      ]
    },
    {
      heading: "Brave: navegador amigo de Web3",
      text: [
        "Brave es un navegador enfocado en privacidad, rendimiento y compatibilidad con Web3. Es una excelente opción para usuarios que utilizan criptomonedas y aplicaciones descentralizadas (DApps).",
        "Bloquea rastreadores, anuncios invasivos y scripts maliciosos por defecto, lo que reduce la superficie de ataque mientras navegas.",
        "Incluye Brave Wallet, una billetera integrada para manejar criptomonedas y conectarse con DApps, sin necesidad de instalar extensiones adicionales como MetaMask (aunque también es compatible con MetaMask si lo prefieres).",
        "Brave también incorpora soporte para tecnologías como IPFS y ofrece un modelo de recompensas con BAT (Basic Attention Token) para quienes deciden ver anuncios privados y opcionales."
      ],
      list: [
        "✅ Ideal para usuarios de blockchain, Web3 y criptomonedas.",
        "✅ Bloqueo nativo de anuncios y rastreadores.",
        "✅ Brave Wallet integrada para conectar con DApps.",
        "✅ Protección contra fingerprinting y rastreo.",
        "✅ Buena compatibilidad con wallets de hardware y extensiones cripto populares."
      ]
    },
    {
      heading: "Tor: anonimato extremo, no para todo",
      text: [
        "Tor (The Onion Router) está diseñado para proteger el anonimato y evitar el rastreo. Es utilizado por personas que necesitan navegar con privacidad extrema, como periodistas, activistas o usuarios en países con censura.",
        "En lugar de ir directo de tu computadora al sitio web, tu tráfico pasa por varias capas de nodos (como capas de cebolla), lo que oculta tu IP real y dificulta el rastreo.",
        "Sin embargo, Tor no está pensado para uso cotidiano ni para operar con criptomonedas de forma intensiva o conectarse a DApps complejas."
      ],
      list: [
        "✅ Oculta tu IP real mediante múltiples saltos cifrados.",
        "✅ Ayuda a evitar vigilancia y censura.",
        "❌ Suele ser más lento que un navegador normal.",
        "❌ Muchos sitios no funcionan bien (banca, verificación por SMS, algunas DApps).",
        "❌ No es buena idea iniciar sesión en cuentas muy personales (Google, redes sociales) si buscas anonimato.",
        "❌ No se recomienda para conectar wallets y firmar transacciones Web3 de uso diario."
      ]
    },
    {
      heading: "Qué navegador usar según la necesidad",
      text: [
        "No existe un único navegador perfecto para todo. Lo más seguro es combinar varios y asignarles roles distintos:",
        "- Brave: para Web3, DApps, DeFi, NFT y uso cripto frecuente con buena privacidad.",
        "- Firefox endurecido: para quienes quieren controlar extensiones, usar NoScript o configuraciones avanzadas de privacidad.",
        "- Chrome/Chromium: para sitios muy exigentes en compatibilidad o cuando necesitas que “todo funcione” (por ejemplo, banca, trámites, videollamadas), pero con menos privacidad.",
        "- Tor: para momentos puntuales donde el anonimato extremo es más importante que la velocidad o la comodidad."
      ],
      list: [
        "⚙️ Usa Brave o un Firefox bien configurado para la mayoría de tus interacciones cripto.",
        "🧭 Reserva Chrome para sitios donde solo funcione bien ahí, pero no lo conviertas en tu navegador principal de Web3.",
        "🧅 Usa Tor solo cuando realmente necesites anonimato fuerte, no como navegador cripto de todos los días."
      ]
    },
    {
      heading: "Extensiones de privacidad recomendadas",
      text: [
        "Hay extensiones que, bien usadas, mejoran tu seguridad y privacidad al navegar, especialmente cuando visitas DApps, sitios de trading o páginas relacionadas con cripto."
      ],
      list: [
        "🧱 uBlock Origin: bloqueador de anuncios y rastreadores muy eficiente. Reduce la superficie de ataque al bloquear scripts y recursos maliciosos.",
        "🔒 HTTPS Everywhere (en navegadores donde aún sea útil): fuerza el uso de HTTPS siempre que sea posible.",
        "🧹 ClearURLs: elimina parámetros de seguimiento y limpia URLs para que compartas y navegues con menos rastreo.",
        "🕵️ Privacy Badger o extensiones similares: bloquean rastreadores invisibles que siguen tu actividad de sitio en sitio."
      ]
    },
    {
      heading: "NoScript y bloqueadores “hardcore”",
      text: [
        "En Firefox existe una extensión legendaria: NoScript. Durante años fue una herramienta clave para bloquear JavaScript en sitios desconocidos y solo permitirlo en aquellos que tú autorices.",
        "Ventajas:",
        "- Detiene muchos payloads maliciosos antes siquiera de que se ejecuten.",
        "- Te obliga a ser consciente de qué sitios realmente necesitan JavaScript.",
        "Desventajas:",
        "- Es incómodo para usuarios principiantes: muchos sitios dejan de funcionar hasta que los autorices manualmente.",
        "- Requiere paciencia y hábito para configurarlo bien.",
        "Hoy en día los navegadores son más seguros y cuentan con políticas como same-origin, CSP (Content Security Policy), cookies más restringidas y mejores aislamientos internos. Eso hace que herramientas tipo NoScript sean menos necesarias para el usuario promedio.",
        "Aun así, si eres una persona muy paranoica o manejas activos de alto valor, puede valer la pena experimentar y encontrar un punto de equilibrio entre seguridad y usabilidad."
      ]
    },
    {
      heading: "Diagrama mental: navegador endurecido",
      text: [
        "Imagina un navegador “endurecido” para uso cripto como un pequeño bunker digital:",
        "- Solo unas pocas extensiones esenciales (wallet, bloqueador de anuncios, quizá una extensión de privacidad).",
        "- Actualizaciones automáticas habilitadas y aplicadas con frecuencia.",
        "- Sin inicios de sesión innecesarios en redes sociales o correos personales.",
        "- Historial y cookies limpiados con regularidad o configurados en modo estricto.",
        "- Uso exclusivo para interactuar con exchanges, DApps y contratos importantes.",
        "No necesitas ver el diagrama para entender la idea: se trata de un entorno controlado, con menos ruido, menos distracciones y, sobre todo, menos superficie de ataque."
      ]
    },
    {
      heading: "Buenas prácticas rápidas para navegadores en cripto",
      list: [
        "🚀 Mantén el navegador siempre actualizado.",
        "🧩 Instala solo las extensiones imprescindibles y revisa permisos.",
        "🧪 Usa un navegador separado para operaciones sensibles (exchanges, DApps importantes, firmas grandes).",
        "🔍 Revisa siempre la barra de direcciones antes de conectar tu wallet.",
        "🧼 Limpia periódicamente extensiones que ya no uses.",
        "🛡️ Combina el uso del navegador seguro con otras capas: sistema operativo actualizado, red confiable y buenas prácticas de seed phrase."
      ]
    },
    {
      heading: "Conclusión: el navegador como puerta a la dark forest",
      text: [
        "Tu navegador es la puerta de entrada al ecosistema cripto y, por tanto, uno de los objetivos favoritos de los atacantes.",
        "Si blindas bien esa puerta —actualizaciones, pocas extensiones, separación de usos y privacidad reforzada— reduces drásticamente tu riesgo, incluso antes de hablar de smart contracts o wallets.",
        "Un navegador bien configurado no hace magia, pero sí evita muchos de los ataques más comunes y silenciosos que circulan en esta dark forest digital."
      ]
    }
  ]
};

export default CAP23;
